export { DEFAULT_BULK_SMS_PROMPT_TEMPLATE } from '@crave/config/bulk-sms-llm-prompt';

export type LlmProvider = 'openai' | 'deepseek';

export const LLM_PROVIDERS: { id: LlmProvider; label: string }[] = [
	{ id: 'openai', label: 'OpenAI' },
	{ id: 'deepseek', label: 'DeepSeek' },
];

export const LLM_PROVIDER_MODELS: Record<LlmProvider, readonly string[]> = {
	openai: ['gpt-4o-mini', 'gpt-4o', 'gpt-4.1-mini', 'gpt-4.1'],
	deepseek: ['deepseek-v4-flash', 'deepseek-v4-pro', 'deepseek-v4-flash-vision-exp'],
};

export const LLM_PROVIDER_DEFAULT_MODEL: Record<LlmProvider, string> = {
	openai: 'gpt-4o-mini',
	deepseek: 'deepseek-v4-flash',
};
